import { render, staticRenderFns } from "./stockInventorySelectedItems.vue?vue&type=template&id=4a6fb4ce"
import script from "./stockInventorySelectedItems.vue?vue&type=script&lang=js"
export * from "./stockInventorySelectedItems.vue?vue&type=script&lang=js"
import style0 from "./stockInventorySelectedItems.vue?vue&type=style&index=0&id=4a6fb4ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports